import { gql } from '@apollo/client';

export const ADD_UPDATE_TEMPLATE = gql`
  mutation addOrUpdateDocumentTemplate($input: DocumentTemplateItemInput) {
    addOrUpdateDocumentTemplate(input: $input) {
      commandId
    }
  }
`;

export const SAVE_FILTERS_TEMPLATE = gql`
  mutation saveDocumentTemplateFilters($input: DocumentTemplateFiltersInput) {
    saveDocumentTemplateFilters(input: $input) {
      commandId
    }
  }
`;

export const SAVE_TEMPLATE_USER_GROUPS = gql`
  mutation saveDocumentTemplateXUserGroups($input: SaveDocumentTemplateXUserGroupsInput) {
    saveDocumentTemplateXUserGroups(input: $input) {
      commandId
    }
  }
`;

export const SAVE_TEMPLATE_SIGNATURES = gql`
  mutation saveDocumentTemplateXSignatures($input: SaveDocumentTemplateXSignaturesInput) {
    saveDocumentTemplateXSignatures(input: $input) {
      commandId
    }
  }
`;

export const SAVE_SIGNATURE_BOOKMARKS = gql`
  mutation saveSignatureBookmarks($input: SaveSignatureBookmarkInput) {
    saveSignatureBookmarks(input: $input) {
      commandId
    }
  }
`;

export const SAVE_DOCUMENT_TEMPLATE_X_OPTION_BOOKMARKS = gql`
  mutation saveDocumentTemplateXOptionBookmarks($input: SaveDocumentTemplateXOptionBookmarksInput) {
    saveDocumentTemplateXOptionBookmarks(input: $input) {
      commandId
    }
  }
`;
